import { useLocation } from "react-router-dom";

const CONTENT = {
  "privacy-policy": {
    title: "Privacy Policy",
    updated: "Ultimo aggiornamento: gennaio 2026",
    intro:
      "La presente informativa descrive il trattamento dei dati personali degli utenti che consultano il sito planitstudio.it, ai sensi del Regolamento UE 2016/679 (GDPR) e del D.Lgs. 196/2003 e successive modifiche.",
    sections: [
      {
        h: "Titolare del trattamento",
        p: "Plan It Studio s.r.l. s.t.p., Via Giuseppe Saragat 12a, 06049 Spoleto (PG), p.iva 03978190548. Email: info@planitstudio.it — PEC: planitstudio@pec.it (da confermare).",
      },
      {
        h: "Tipologia dei dati raccolti",
        p: "I dati raccolti attraverso i moduli di contatto e prenotazione includono: nome e cognome, indirizzo email, numero di telefono, messaggio, motivo della visita. Vengono inoltre raccolti dati di navigazione tramite cookie tecnici (vedi Cookie Policy).",
      },
      {
        h: "Finalità del trattamento",
        p: "I dati vengono utilizzati esclusivamente per rispondere alle richieste degli utenti, gestire prenotazioni visite, inviare comunicazioni relative ai servizi richiesti e adempiere agli obblighi di legge. Non vengono ceduti a terzi.",
      },
      {
        h: "Base giuridica",
        p: "Il trattamento è basato sul consenso esplicito dell'utente (art. 6 lett. a GDPR) e sull'esecuzione di misure precontrattuali (art. 6 lett. b GDPR).",
      },
      {
        h: "Periodo di conservazione",
        p: "I dati vengono conservati per il tempo necessario a soddisfare le finalità e comunque per un massimo di 24 mesi salvo obblighi normativi diversi.",
      },
      {
        h: "Diritti dell'interessato",
        p: "In qualsiasi momento l'utente può esercitare i diritti di accesso, rettifica, cancellazione, limitazione, portabilità e opposizione scrivendo a info@planitstudio.it. È inoltre possibile proporre reclamo al Garante per la Protezione dei Dati Personali.",
      },
    ],
  },
  "cookie-policy": {
    title: "Cookie Policy",
    updated: "Ultimo aggiornamento: gennaio 2026",
    intro:
      "Il sito planitstudio.it utilizza esclusivamente cookie tecnici necessari al corretto funzionamento delle sue funzionalità. Non vengono utilizzati cookie di profilazione né di marketing.",
    sections: [
      {
        h: "Cookie tecnici",
        p: "Sono cookie strettamente necessari per la navigazione del sito e per l'erogazione di servizi richiesti dall'utente (ad esempio il ricordo della lingua selezionata IT/EN e la sessione di accesso all'area staff). Non richiedono consenso.",
      },
      {
        h: "Cookie di terze parti",
        p: "Il sito incorpora contenuti da servizi esterni (Google Maps, Instagram) che possono rilasciare cookie propri. Per maggiori informazioni consultare le rispettive privacy policy.",
      },
      {
        h: "Gestione dei cookie",
        p: "L'utente può in ogni momento gestire e disabilitare i cookie tramite le impostazioni del proprio browser. La disabilitazione di alcuni cookie tecnici potrebbe compromettere la corretta fruizione del sito.",
      },
    ],
  },
  "note-legali": {
    title: "Note Legali",
    updated: "Ultimo aggiornamento: gennaio 2026",
    intro:
      "Il sito planitstudio.it è di proprietà di Plan It Studio s.r.l. s.t.p., con sede in Via Giuseppe Saragat 12a, 06049 Spoleto (PG), p.iva 03978190548.",
    sections: [
      {
        h: "Proprietà dei contenuti",
        p: "Tutti i contenuti presenti sul sito (testi, immagini, marchi, loghi, grafiche, planimetrie, elaborati di progetto) sono di proprietà esclusiva di Plan It Studio s.r.l. s.t.p. o dei rispettivi titolari e sono protetti dalle leggi vigenti in materia di diritto d'autore e proprietà industriale. È vietata qualsiasi riproduzione, anche parziale, senza autorizzazione scritta.",
      },
      {
        h: "Limitazione di responsabilità",
        p: "Plan It Studio s.r.l. s.t.p. non è responsabile per eventuali danni diretti o indiretti derivanti dall'uso del sito o dei contenuti in esso pubblicati. Il sito può contenere link a siti terzi di cui non si assume alcuna responsabilità.",
      },
      {
        h: "Legge applicabile e foro competente",
        p: "L'utilizzo del sito è disciplinato dalla legge italiana. Per qualsiasi controversia sarà competente in via esclusiva il Foro di Perugia.",
      },
      {
        h: "Modifiche",
        p: "Plan It Studio s.r.l. s.t.p. si riserva il diritto di modificare in qualsiasi momento i contenuti del sito e le presenti note legali, senza alcun preavviso.",
      },
    ],
  },
};

export default function Legal() {
  const { pathname } = useLocation();
  const key = pathname.replace(/^\/+/, "");
  const data = CONTENT[key] || CONTENT["privacy-policy"];

  return (
    <div className="max-w-4xl mx-auto px-6 lg:px-10 py-20 lg:py-24">
      <div className="text-center">
        <h1 className="font-serif text-5xl lg:text-6xl text-stone-900" data-testid="legal-title">{data.title}</h1>
        <div className="mt-4 w-16 h-[2px] bg-[#D06D4D] mx-auto" aria-hidden="true" />
        <p className="mt-4 text-xs uppercase tracking-widest text-stone-500">{data.updated}</p>
      </div>

      <p className="mt-12 text-stone-700 text-lg leading-relaxed">{data.intro}</p>

      <div className="mt-10 space-y-8">
        {data.sections.map((s, i) => (
          <section key={s.h} data-testid={`legal-section-${i}`}>
            <h2 className="font-serif text-2xl text-stone-900">{s.h}</h2>
            <p className="mt-3 text-stone-700 leading-relaxed">{s.p}</p>
          </section>
        ))}
      </div>
    </div>
  );
}
